enum CartErrors {
  CART_NOT_FOUND = 'CART_NOT_FOUND',
  TASK_ALREADY_EXISTS = 'TASK_ALREADY_EXISTS'
}

export { CartErrors };
